module.exports = __webpack_public_path__ + "d322c23c33bc3af971ba84c9843ac920.png";